module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators 1.9cc832e5.jpg";